// @flow

import React from "react";
import classNames from "classnames";

import StatTile from "./stat-tile";
import type { StatTileProps } from "./stat-tile";

type Props = $Exact<{
  data: StatTileProps[],
  className?: string,
}>;

const StatTileGroup = ({ data, className }: Props) => (
  <div className={classNames("w-100 stat-tile-group", className)}>
    {Boolean(data?.length) && data.map(el => <StatTile key={el.title} {...el} />)}
  </div>
);

export default StatTileGroup;
